
/*global kakao*/
import { useEffect, useState } from "react"

import {
  Grid,
  Tab,
  Box,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
  Snackbar,
  Typography,
} from "@mui/material";

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import get_center from '../lib/get_center';
import get_cid from '../lib/get_cid';

function CenterMap() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const cid = get_cid();
  const center = get_center(cid);

  useEffect(() => {
    center.center_info.map((i, idx) => {
      var container = document.getElementById('map');
      var options = {
        center: new kakao.maps.LatLng(i.latitude, i.longitude),
        level: 3
      };

      var map = new kakao.maps.Map(container, options);
      var markerPosition = new kakao.maps.LatLng(i.latitude, i.longitude);
      var marker = new kakao.maps.Marker({
        position: markerPosition,
      });
      marker.setMap(map);
    })
  }, [])

  const copyAction = () => {
    // navigator.clipboard.writeText(text);
    setOpen(true);
  }

  const closeSnack = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }
  return (
    <>
      <Grid id='map' style={{ width: '100%', height: '250px' }}></Grid>
      {center.center_info.map((item, index) => {
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
            key={index}>
          
            <Box
              sx={{
                fontSize: '17px',
                fontWeight: 'bold',
                marginTop: '15px'
              }}>
              오시는 길
            </Box>
            <Box
              sx={{
                marginTop: '15px',
                fontWeight: 'bold',
              }}>
              주소
            </Box>
            <Box
              sx={{
                marginBottom: '15px',
                display: 'flex',
                alignItem: 'center'
              }}
              onClick={()=>copyAction()}>
              <CopyToClipboard text={item.address} onCopy={() => setCopied(true)}>
              <Typography fontSize='14px'>{item.address}</Typography>
              </CopyToClipboard>
              &nbsp;<ContentCopyIcon fontSize='small' />
            </Box>
            <Box
              sx={{
                fontWeight: 'bold'
              }}>
              교통편
            </Box>
            <Box
              sx={{
                fontSize: '15px',
                fontWeight: 'bold'
              }}>
              버스
            </Box>
            {item.transportation.map((i, idx) => {
              return(
              <Box
                sx={{
                  fontSize: '14px'
                }}
                key={idx}>
                {i.bus}
              </Box>
              )
            })}
            <Snackbar open={open} autoHideDuration={3000} onClose={closeSnack}>
            <Alert onClose={closeSnack} width='100%'>
              복사 되었습니다
            </Alert>
            </Snackbar>
            
          </Box>
        )
      })}
      


    </>
  )
}

export default CenterMap;